<template>
  <b-card class="mb-4 p-2">
    <h4 class="title-card">{{ titulo }}</h4>
    <p class="text-card mt-4">{{ texto }}</p>
  </b-card>
</template>

<script>
export default {
  name: 'ComunicadoCard',
  props: {
    titulo: {
      type: String,
      required: true
    },
    texto: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.title-card { 
    font-size: 20px; 
    color: #212529; 
    font-family: "Trebuchet MS", sans-serif;
}
.text-card { 
    font-size: 12px; 
    color: #212529; 
    font-family: "Trebuchet MS", sans-serif;
}
</style>